<template>
  <div class="core_wrap1">
    <div class="brain_title hidden-xs-only">可靠的服务团队，提供专业化服务</div>
    <div class="brain_title hidden-sm-and-up">专家团队提供专业服务</div>
    <div class="brain_desc hidden-xs-only">专业化团队，实时化响应，可视化流程，一站式服务，全方位满足您的需求</div>
    <div class="brain_desc hidden-sm-and-up">一站式服务，全方位满足您的需求</div>

    <el-row class="card_wrap hidden-xs-only" type="flex">
      <el-col
          class="brain_item"
          :span="5"
          v-for="(item, index) in cardList"
          :key="index"
      >
        <div class="item_bg"></div>
        <el-row style="z-index: 2">
          <el-col :span="5">
            <img :src="item.src" alt="" class="img_item1"/>
          </el-col>
          <el-col :span="19" style="padding-left: 5px">
            <div class="item_title">{{ item.title }}</div>
            <div class="item_desc"><i class="el-icon-check" style="padding-left: 0"></i>{{ item.desc1 }}<i class="el-icon-check"></i>{{ item.desc2 }}<i class="el-icon-check"></i>{{ item.desc3 }}</div>
          </el-col>
        </el-row>

        <!--        <div class="item_title">{{ item.title }}</div>-->
        <!--        <div class="item_desc">{{ item.desc }}</div>-->
        <!--        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>-->
        <!--        <div class="item_bg"></div>-->
      </el-col>
    </el-row>
    <el-row class="hidden-sm-and-up">
      <el-col
          class="brain_item_mobile"
          :span="12"
          v-for="(item, index) in cardList"
          :key="index"
      >
        <el-row class="brain_item_mobile_inner">
          <el-col :span="6">
            <img :src="item.src" alt="" class="img_item1"/>
          </el-col>
          <el-col :span="18" style="padding-left: 5px">
            <div class="item_title">{{ item.title }}</div>
            <div class="item_desc"><i class="el-icon-check" style="padding-left: 0"></i>{{ item.desc1 }}</div>
            <div class="item_desc"><i class="el-icon-check"></i>{{ item.desc2 }}</div>
            <div class="item_desc"><i class="el-icon-check"></i>{{ item.desc3 }}</div>
          </el-col>
        </el-row>

        <!--        <div class="item_title">{{ item.title }}</div>-->
        <!--        <div class="item_desc">{{ item.desc }}</div>-->
        <!--        <div class="item_navigate" @click="handleNavigate">了解详情 >></div>-->
        <!--        <div class="item_bg"></div>-->
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cardList: [
        {
          src: require('@/assets/img/item/item7.svg'),
          title: '专业',
          desc1: '专业团队',
          desc2: '经验丰富',
          desc3: '流程标准',
        },
        {
          src: require('@/assets/img/item/item8.svg'),
          title: '快捷',
          desc1: '7*24小时',
          desc2: '实时响应',
          desc3: '沟通无碍',
        },
        {
          src: require('@/assets/img/item/item9.svg'),
          title: '高效',
          desc1: '流程简洁',
          desc2: '无缝衔接',
          desc3: '快速解决',
        },
        {
          src: require('@/assets/img/item/item10.svg'),
          title: '放心',
          desc1: '专属售后',
          desc2: '定期回访',
          desc3: '过程透明',
        },
      ],
    }
  },
  methods: {
    changeCurrentIndex(index) {
      this.currentIndex = index
      this.coresList.map((v, i) => {
        i === index ? (v.isActive = true) : (v.isActive = false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.core_wrap1 {
  width: 100%;
  margin-top: 20px;
  padding-top: 10px;
  padding-bottom: 100px;
  text-align: center;
  background-color: #F5F7FA;
  @media screen and (max-width: 768px) {
    margin-top: 0;
    padding-top: 10PX;
  }
  .brain_title {
    color: #203040;
    font-size: 33px;
    font-weight: bold;
    padding: 40px 0 10px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.1rem;
    }
  }
  .brain_desc {
    //color: rgba(32, 48, 64, 0.75);
    font-size: 14px;
    letter-spacing: 1px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 30PX;
    }
  }
  .core_options {
    width: 70%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      width: 90%;
    }
    .core_items {
      width: 30%;
      height: 70px;
      border: solid 1px #04cac7;
      font-size: 30px;
      line-height: 70px;
      user-select: none;
      cursor: pointer;
      margin-bottom: 40px;
    }
    .core_items2{
      width: 30%;
      height: 100PX;
      display: flex;
      justify-content: center;
      align-items: center;
      border: solid 1px #04cac7;
      padding: 5PX;
      font-size: 0.9rem;
    }
    .is_active {
      color: #fff;
      font-weight: bold;
      background: linear-gradient(134deg, #0649b8 1%, #0a7fd7 41%, #03d2c5 99%);
      box-shadow: 0 0.5rem 1.5rem 0 rgb(0 135 168 / 50%);
    }
  }
}
.card_wrap {
  width: 70%;
  flex-wrap: wrap;
  margin: 0px auto;
  justify-content: space-between;
  @media screen and (max-width: 768px) {
    width: 95%;
    margin: auto;
  }
  .brain_item {
    transition: background-color 1s;
    padding: 10px 0px 10px 0;
    //background: #fff;
    border-radius: 4px;
    border: 2px solid #fff;
    background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
    box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 10%);
    margin-top: 40px;
    position: relative;
    @media screen and (max-width: 768px) {
      position: unset;
      font-size: 0.8rem;
      line-height: 40PX;
      border-radius: 10PX;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      margin-top: 20PX;
      &:nth-child(-n+2){
        margin-top: 0;
      }
    }
    .img_item1 {
      margin-top: 10px;
      width: 100% ;
    }
    &:hover{
      box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 18%);
    }
    .item_bg {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
      //box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 12%);
      opacity: 0;
      transition: all 0.5s;
      border-radius: 4px;
      z-index: 1;
      border: 1px solid #fff;
    }
    &:hover .item_bg{
      opacity: 1;
    }
    &:hover .item_title {
      color: #0052D9;
    }
    //&:hover .item_desc {
    //  color: #0052D9;
    //}
    .item_title {
      transition: all 0.5s;
      font-size: 18px;
      font-weight: bold;
      color: #203040;
      text-align: left;
      padding: 10px 0 10px 0;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        font-size: 1rem;
        text-align: center;
      }
    }
    .item_desc {
      transition: all 0.5s;
      color: #666;
      text-align: left;
      //line-height: 1.5rem;
      z-index: 2;
      position: inherit;
      font-size: 12px;
      min-height: 30px;
      @media screen and (max-width: 768px) {
        min-height: 110PX;
        text-indent: 2em;
        font-size: 12px;
      }
      i{
        padding: 0 5px 0 5px;
        color: #19B21E;
        font-weight: bold
      }
    }
    .item_navigate {
      width: 100PX;
      height: 30PX;
      padding: 0 10px;
      background: #ffa400;
      color: #fff;
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 14px;
      margin-top: 40px;
      cursor: pointer;
      z-index: 2;
      position: inherit;
      @media screen and (max-width: 768px) {
        margin-bottom: 10PX;
        font-size: 14px;
      }
    }
  }

}
.brain_item_mobile {


  padding:10PX 10PX 0 10PX;
  .brain_item_mobile_inner{
    border-radius: 4PX;
    border: 2px solid #fff;
    background: linear-gradient(180deg, #F3F5F8 0%, #FFFFFF 100%);
    box-shadow: 0 0.5rem 1.5rem 0.5rem rgb(12 28 56 / 6%);
    padding: 20PX;
  }
  @media screen and (max-width: 768px) {
    position: unset;
    font-size: 0.8rem;
    line-height: 18PX;
    border-radius: 10PX;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin-top: 10PX;
    &:nth-child(-n+2){
      margin-top: 0;
    }
  }
  .img_item1 {
    margin-top: 10px;
    width: 100% ;
  }
  //&:hover .item_desc {
  //  color: #0052D9;
  //}
  .item_title {
    transition: all 0.5s;
    font-size: 1rem;
    font-weight: bold;
    color: #203040;
    text-align: left;
    z-index: 2;
    position: inherit;
    margin-left: 5PX;
    margin-bottom: 10PX;
    margin-top: 8PX;
  }
  .item_desc {
    transition: all 0.5s;
    color: #666;
    text-align: left;
    //line-height: 1.5rem;
    z-index: 2;
    position: inherit;
    font-size: 12px;
    min-height: 30px;
    @media screen and (max-width: 768px) {
      height:30PX;
      font-size: 12PX;
    }
    i{
      padding: 0 10PX 0 0;
      color: #19B21E;
      font-weight: bold
    }
  }
  .item_navigate {
    width: 100PX;
    height: 30PX;
    padding: 0 10px;
    background: #ffa400;
    color: #fff;
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    margin-top: 40px;
    cursor: pointer;
    z-index: 2;
    position: inherit;
    @media screen and (max-width: 768px) {
      margin-bottom: 10PX;
      font-size: 14px;
    }
  }

}
</style>